import React, { useState, useEffect, useCallback, useContext, useRef } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import PdfFile from "./PdfFile";
import WordFile from "./WordFile";
import "react-datepicker/dist/react-datepicker.css";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import pdficon from "./../Asset/PDF.png";
import { Commonfun } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import Keywordbar from "./../Rightsidebar/Keywordbar";
import { timezoneval } from './../Commonfun';
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Commoncard from "../Commoncard";
import UserActivityTracker from "../../../hooks/userActivityTracker";



export default function ContentauditDetail() {
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobDate, setJobDate] = useState("");
  const [toggle, setToggle] = useState(false);
  const [faqData, setFaqData] = useState("2");
  const [initialFaqDataVal, setInitialFaqDataVal] = useState([]);
  const [apiOpen, setApiOpen] = useState(false);
  const [apiErrorMsg, setApiErrorMsg] = useState();
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [initialDateval, SetInitialDateval] = useState([]);

  const { jobid } = useParams();
  let cont_audit_id = jobid;
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [isDownloading, setIsDownloading] = useState(false);


  useEffect(() => {
    callUserdataApi();
    faqdatafun();
  }, [cont_audit_id, esodata.domaindata.value.header_selected, ApiToken]);

  const callUserdataApi = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/file_accessibility_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${cont_audit_id}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      );
      setCardData(response.data);
    } catch (error) {
      if (error?.response?.status === 599 || error?.response?.status === 400 || error?.response?.status === 500) {
        setApiOpen(true);
        setApiErrorMsg(error?.response?.data?.error);
      } else if (error?.code === "ERR_NETWORK" || error?.response?.status === 404) {
        navigate('/errorpages');
      }
    } finally {
      setLoading(false);
    }
  }, [cont_audit_id, esodata.domaindata.value.header_selected, ApiToken, navigate]);

  const faqdatafun = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=55`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      );
      SetInitialDateval(response?.data?.faqs)

    } catch (error) {
      if (error?.response?.status === 599 || error?.response?.status === 400 || error?.response?.status === 500) {
        setApiOpen(true);
        setApiErrorMsg(error?.response?.data?.error);
      } else if (error?.code === "ERR_NETWORK" || error?.response?.status === 404) {
        navigate('/errorpages');
      }
    }
  }, [ApiToken, navigate]);

  const handleToggle = useCallback(() => {
    setFaqData(prevFaqData => prevFaqData !== "1" ? "1" : "2");
    setToggle(prevToggle => !prevToggle);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const classList = event.target.classList;
      const toggleFaqData = () => {
        setFaqData("2");
        setToggle(false);
      };
      const allowedClasses = [
        'cnt_hdr_blw_wrap', 'header_wrap', 'nav_key_txt', 'cnt_hdr_top_wrap', 'react-dropdown-select',
        'react-dropdown-select-content', 'react-dropdown-select-item', 'site_cnt_hdr_blw_wrap', 'App',
        'cnt_audit_outer_wrap', 'MuiDataGrid-columnHeaderTitleContainer', 'MuiDataGrid-toolbarContainer',
        'MuiDataGrid-row', 'MuiDataGrid-cell', 'MuiDataGrid-cellContent', 'header_inner_btm_wrap', 'over_all_container',
        'input_domain_field', 'react-dropdown-select-input', 'cnt_hdr_content_table', 'hor_line', 'box_wrap', 'table', 'undefined'
      ];
      if (allowedClasses.includes(classList[0])) {
        toggleFaqData();
      }
    };

    const rootElement = document.getElementById('root');
    rootElement.addEventListener('click', handleClick);

    return () => {
      rootElement.removeEventListener('click', handleClick);
    };
  }, []);
  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/file_accessibility_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${cont_audit_id}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("FileAccessibilityDetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>File Accessibility Detail</title>
      </Helmet>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div>
                <h1 className="dashboard_header">
                  File Accessibility Detail Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Technical' },
                      { title: 'File Accessibility', activeColor: true, link: '/accessibility-file' },
                      { title: 'File Accessibility Detail Report', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="">
                {cardData?.detailed_data?.file_type === "pdf" ? (
                  <PdfFile cardData={cardData} setCardData={setCardData} />
                ) : (
                  <WordFile cardData={cardData} setCardData={setCardData} />
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">

              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {toggle && <Keywordbar close={() => setToggle(false)} setToggle={setToggle} initialDateval={initialDateval} />}

      <UserActivityTracker pagename="Technical - File Accessibility - File Accessibility Detail Report" />
      {/* <div className="cnt_audit_outer_wrap">
        <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'File Accessibility', activeColor: true, link: '/accessibility-file' },
            { title: 'File Accessibility Detail Report', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />

            </button>
            <>
              <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>
            </>
          </div>
          {toggle && <Keywordbar close={() => setToggle(false)} setToggle={setToggle} initialDateval={initialDateval} />}

        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>File Accessibility Detail Report</h2>
            </div>
          </div>
        </div>

      </div>
      {cardData?.detailed_data?.file_type === "pdf" ? (
        <PdfFile cardData={cardData} setCardData={setCardData} />
      ) : (
        <WordFile cardData={cardData} setCardData={setCardData} />
      )} */}
    </div>
  );
}
